var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p_main"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"info-item"},[_vm._v(" "+_vm._s(_vm.systemConfig.TASK_FA_DAN_TI_SHI)+" ")])]),_c('div',{staticClass:"trial-list"},_vm._l((_vm.data),function(item){return _c('TemplateItem',{key:item.id,attrs:{"data":item},on:{"refresh":_vm.getList}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }